/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropEngagementType } from './DropEngagementType';
import {
    DropEngagementTypeFromJSON,
    DropEngagementTypeFromJSONTyped,
    DropEngagementTypeToJSON,
    DropEngagementTypeToJSONTyped,
} from './DropEngagementType';
import type { DropSectionCompetitionFilter } from './DropSectionCompetitionFilter';
import {
    DropSectionCompetitionFilterFromJSON,
    DropSectionCompetitionFilterFromJSONTyped,
    DropSectionCompetitionFilterToJSON,
    DropSectionCompetitionFilterToJSONTyped,
} from './DropSectionCompetitionFilter';
import type { SurfaceSectionType } from './SurfaceSectionType';
import {
    SurfaceSectionTypeFromJSON,
    SurfaceSectionTypeFromJSONTyped,
    SurfaceSectionTypeToJSON,
    SurfaceSectionTypeToJSONTyped,
} from './SurfaceSectionType';

/**
 * Drop navigation section configuration (sibling of HubSection).
 * @export
 * @interface DropSection
 */
export interface DropSection {
    /**
     * Subdocument id (assigned by Mongo) — required for clients that need to address an individual section by id (reorder/edit/delete).
     * @type {string}
     * @memberof DropSection
     */
    _id?: string;
    /**
     * 
     * @type {SurfaceSectionType}
     * @memberof DropSection
     */
    type?: SurfaceSectionType;
    /**
     * 
     * @type {string}
     * @memberof DropSection
     */
    label?: string;
    /**
     * The rail item's second line. Authored copy; live state (streak days, spin readiness) overrides it at render time.
     * @type {string}
     * @memberof DropSection
     */
    sublabel?: string;
    /**
     * What this section is called IN THE NAV, when that differs from its heading. A nav entry has a few characters to work with; a heading has a line. Unset uses the label. Sibling of the same field on SurfaceContentBlock.
     * @type {string}
     * @memberof DropSection
     */
    navLabel?: string;
    /**
     * READ-ONLY. True on rows synthesized at read time from an engagement PLACED on this surface rather than authored into the section list. Never stored — a writer must drop these rows rather than persist them, or a view becomes an inline section.
     * @type {boolean}
     * @memberof DropSection
     */
    fromPlacement?: boolean;
    /**
     * 
     * @type {string}
     * @memberof DropSection
     */
    icon?: string;
    /**
     * 
     * @type {number}
     * @memberof DropSection
     */
    order?: number;
    /**
     * 
     * @type {boolean}
     * @memberof DropSection
     */
    enabled?: boolean;
    /**
     * For MISSIONS type - specific challenge to display
     * @type {string}
     * @memberof DropSection
     */
    challengeId?: string;
    /**
     * 
     * @type {DropSectionCompetitionFilter}
     * @memberof DropSection
     */
    competitionFilter?: DropSectionCompetitionFilter;
    /**
     * For SQUADS type - specific guild
     * @type {string}
     * @memberof DropSection
     */
    guildId?: string;
    /**
     * For CUSTOM type - HTML/markdown content
     * @type {string}
     * @memberof DropSection
     */
    customContent?: string;
    /**
     * 
     * @type {DropEngagementType}
     * @memberof DropSection
     */
    engagementType?: DropEngagementType;
    /**
     * For ENGAGEMENT type - which specific thing this section shows. Picked by name in the editor, never typed.
     * @type {string}
     * @memberof DropSection
     */
    engagementId?: string;
    /**
     * For ENGAGEMENT type - the assigned thing's display name, resolved at route time. Read-only.
     * @type {string}
     * @memberof DropSection
     */
    engagementName?: string;
}



/**
 * Check if a given object implements the DropSection interface.
 */
export function instanceOfDropSection(value: object): value is DropSection {
    return true;
}

export function DropSectionFromJSON(json: any): DropSection {
    return DropSectionFromJSONTyped(json, false);
}

export function DropSectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropSection {
    if (json == null) {
        return json;
    }
    return {
        
        '_id': json['_id'] == null ? undefined : json['_id'],
        'type': json['type'] == null ? undefined : SurfaceSectionTypeFromJSON(json['type']),
        'label': json['label'] == null ? undefined : json['label'],
        'sublabel': json['sublabel'] == null ? undefined : json['sublabel'],
        'navLabel': json['navLabel'] == null ? undefined : json['navLabel'],
        'fromPlacement': json['fromPlacement'] == null ? undefined : json['fromPlacement'],
        'icon': json['icon'] == null ? undefined : json['icon'],
        'order': json['order'] == null ? undefined : json['order'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'challengeId': json['challengeId'] == null ? undefined : json['challengeId'],
        'competitionFilter': json['competitionFilter'] == null ? undefined : DropSectionCompetitionFilterFromJSON(json['competitionFilter']),
        'guildId': json['guildId'] == null ? undefined : json['guildId'],
        'customContent': json['customContent'] == null ? undefined : json['customContent'],
        'engagementType': json['engagementType'] == null ? undefined : DropEngagementTypeFromJSON(json['engagementType']),
        'engagementId': json['engagementId'] == null ? undefined : json['engagementId'],
        'engagementName': json['engagementName'] == null ? undefined : json['engagementName'],
    };
}

export function DropSectionToJSON(json: any): DropSection {
    return DropSectionToJSONTyped(json, false);
}

export function DropSectionToJSONTyped(value?: DropSection | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '_id': value['_id'],
        'type': SurfaceSectionTypeToJSON(value['type']),
        'label': value['label'],
        'sublabel': value['sublabel'],
        'navLabel': value['navLabel'],
        'fromPlacement': value['fromPlacement'],
        'icon': value['icon'],
        'order': value['order'],
        'enabled': value['enabled'],
        'challengeId': value['challengeId'],
        'competitionFilter': DropSectionCompetitionFilterToJSON(value['competitionFilter']),
        'guildId': value['guildId'],
        'customContent': value['customContent'],
        'engagementType': DropEngagementTypeToJSON(value['engagementType']),
        'engagementId': value['engagementId'],
        'engagementName': value['engagementName'],
    };
}

